import { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import { api, monthYear } from "@/lib/api";
import { Stars } from "@/components/Stars";
import Reveal from "@/components/Reveal";

export default function KindWords() {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    let active = true;
    api
      .get("/reviews")
      .then((res) => active && setReviews(res.data || []))
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  if (!reviews.length) return null;

  return (
    <section
      id="kind-words"
      className="relative px-6 sm:px-10 md:px-16 lg:px-24 py-24 sm:py-32 bg-[color:var(--paper-2)]/50 border-y border-[color:var(--rule)]"
      data-testid="kind-words-section"
    >
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <p className="eyebrow">
            <span className="text-[color:var(--gold)]">·</span> Kind words
          </p>
          <span className="rule" />
          <h2 className="font-display text-4xl sm:text-5xl leading-[0.95] tracking-tight max-w-2xl">
            What guests carried<br />
            <em className="italic text-[color:var(--moss)]">home with them.</em>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12">
          {reviews.map((r, i) => (
            <Reveal key={r.id} delay={(i % 2) * 0.08}>
              <figure
                className="h-full border border-[color:var(--rule)] bg-[color:var(--paper)] p-7 sm:p-9 flex flex-col"
                data-testid={`review-card-${r.id}`}
              >
                <Quote className="w-6 h-6 text-[color:var(--gold)]" />
                <Stars value={r.rating} size={16} className="mt-4" />
                <blockquote className="font-body text-lg sm:text-xl leading-relaxed text-[color:var(--ink)] italic mt-4 flex-1">
                  “{r.note}”
                </blockquote>
                <figcaption className="mt-6">
                  <p className="font-hand text-2xl text-[color:var(--moss)] leading-none">{r.author_name}</p>
                  {r.visit_date && (
                    <p className="eyebrow mt-2">{monthYear(r.visit_date)}</p>
                  )}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
